import React from 'react';
import { cx } from '@emotion/css';
import type { IconProps } from '../Icon';
import { Black } from '../constants/colors';
import { Sizes } from '../constants/sizes';

const RocketIcon = (props: IconProps): JSX.Element => {
  const {
    className,
    'data-testid': dataTestId,
    fill = Black.V100,
    size = Sizes.Medium,
    onClick,
    onMouseEnter,
    onMouseLeave,
  } = props;
  const classNames = cx('sds-icon', 'sds-icon-rocket', className);
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill={fill}
      xmlns='http://www.w3.org/2000/svg'
      className={classNames}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      data-testid={dataTestId}
    >
      <path d='M10.9262 5.07408C10.4606 4.60765 9.70517 4.60765 9.23953 5.07408C8.77389 5.53973 8.77389 6.29512 9.23953 6.76077C9.70517 7.22641 10.4606 7.22641 10.9262 6.76077C11.3926 6.29512 11.3926 5.53973 10.9262 5.07408Z' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.9773 2.02251L13.4308 2.00287C13.269 1.99502 9.40882 1.88352 7.00524 4.28555C6.91979 4.37164 6.84315 4.45979 6.7669 4.5475L6.71392 4.60828C5.87687 4.47401 4.40457 4.5329 2.92205 6.01542L2.22163 6.71585L5.29344 7.62515C5.03746 9.04172 5.27224 10.1787 5.28952 10.2604L5.3704 10.6295L5.73945 10.7103C5.79285 10.7229 6.29697 10.8266 7.03508 10.8266C7.41199 10.8266 7.85329 10.7928 8.32285 10.7119L9.46379 13.5992L10.0983 12.9647C11.569 11.494 11.5784 10.0303 11.4339 9.24117C11.4658 9.21308 11.4979 9.18618 11.53 9.15929C11.5921 9.10722 11.6542 9.05518 11.7143 8.9946C14.1178 6.591 14.0032 2.73236 13.9977 2.56981L13.9773 2.02251ZM9.46929 10.408C9.74726 10.3083 10.0276 10.1842 10.3063 10.0335C10.2844 10.4143 10.1768 10.8823 9.85876 11.3943L9.46929 10.408ZM7.83837 5.11868C9.37113 3.58669 11.7221 3.26161 12.8049 3.19565C12.739 4.2777 12.4139 6.62948 10.8819 8.16225C9.33423 9.70916 7.24474 9.69896 6.38648 9.61415C6.30246 8.75275 6.29225 6.6656 7.83837 5.11868ZM4.58909 6.18817C5.0885 5.88978 5.54786 5.77828 5.92791 5.74923C5.79835 5.99579 5.69548 6.24314 5.60439 6.4897L4.58909 6.18817Z'
      />
      <path d='M4.27704 10.8898C4.50712 10.6597 4.8801 10.6597 5.11017 10.8898C5.34024 11.1198 5.34024 11.4928 5.11017 11.7229L3.53186 13.3012C3.41643 13.4166 3.26567 13.474 3.11491 13.474C2.96493 13.474 2.81416 13.4166 2.69874 13.3012C2.46866 13.0711 2.46866 12.6989 2.69874 12.4689L4.27704 10.8898Z' />
      <path d='M3.00568 10.6704L4.58399 9.09134C4.81406 8.86127 4.81406 8.48907 4.58399 8.25899C4.35392 8.02892 3.98172 8.02892 3.75165 8.25899L2.17255 9.83732C1.94248 10.0674 1.94248 10.4404 2.17255 10.6704C2.28798 10.7851 2.43875 10.8432 2.58951 10.8432C2.74027 10.8432 2.89104 10.7851 3.00568 10.6704Z' />
      <path d='M5.33011 13.8272C5.10004 13.5972 5.10004 13.225 5.33011 12.9949L6.90842 11.4158C7.13849 11.1857 7.51148 11.1857 7.74155 11.4158C7.97162 11.6459 7.97162 12.0189 7.74155 12.2489L6.16246 13.8272C6.04781 13.9427 5.89705 14 5.74628 14C5.59552 14 5.44476 13.9427 5.33011 13.8272Z' />
    </svg>
  );
};

export default RocketIcon;
